import { keyframes, styled } from "goober";
import { BannerTitle } from "./BranchBanner";
import type { ChatBannerParts } from "./BranchSelector";
import { PressButton } from "./PressButton";
import { ToastCardContainer } from "./Toast";

const dropIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;

const Card = styled(ToastCardContainer)`
  flex-shrink: 0;
  height: 36px;
  &[data-enter="true"] {
    animation: ${dropIn} var(--motion-base) var(--ease-out);
  }
  background:
    linear-gradient(
      light-dark(transparent, var(--alpha2)),
      light-dark(transparent, var(--alpha2))
    ),
    var(--surface-primary);
`;

const TriggerRow = styled("div")`
  position: relative;
  display: flex;
  flex: 1;
  min-width: 0;
  height: 28px;
  margin: -2px -2px -2px -6px;
  padding: 4px 2px 4px 6px;
`;

const TriggerButton = styled(PressButton)`
  position: absolute;
  inset: 0;
  border-radius: 8px;
  ${TriggerRow}:hover &,
  &[aria-expanded="true"] {
    background: var(--alpha4);
  }
`;

const TriggerContent = styled("div")`
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
  pointer-events: none;
`;

const Interactive = styled("div")`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  pointer-events: auto;
`;

export function ChatWorkflowBanner({
  parts,
  entering,
}: {
  parts: ChatBannerParts;
  entering: boolean;
}) {
  // Read once into a callback, or React Compiler treats every `parts.anchor` read as a ref read during render.
  const anchorRef = parts.anchor.ref;
  const attachCard = (element: HTMLDivElement | null) => anchorRef(element);
  return (
    <Card
      ref={attachCard}
      role="group"
      aria-label="Workflow"
      data-enter={entering}
      style={{ anchorName: parts.anchor.anchorName }}
      onKeyDown={parts.anchor.onKeyDown}
    >
      <TriggerRow>
        <TriggerButton
          data-no-pill
          aria-label={`${parts.name} history`}
          aria-expanded={parts.history.open}
          onPress={parts.history.onToggle}
        >
          {null}
        </TriggerButton>
        <TriggerContent>
          {parts.icon}
          <BannerTitle name={parts.name} metadata={parts.metadata} />
          <Interactive style={{ gap: 4, marginLeft: "auto" }}>
            {parts.controls}
          </Interactive>
          {parts.avatar && (
            <Interactive style={{ marginRight: 4 }}>{parts.avatar}</Interactive>
          )}
        </TriggerContent>
      </TriggerRow>
      {parts.historyMenu}
    </Card>
  );
}
